<div
  class="madesi-grid root-page"
  [ngClass]="{
    tablet: globalUtilsService.isTablet(),
    mobile: globalUtilsService.isMobile()
  }"
>
  <div class="spotlight-section">
    <section class="spotlight">
      <app-spotlight-section
        style="display: block; width: 100%; height: 100%;"
      ></app-spotlight-section>
    </section>
  </div>
  <div class="contact-section">
    <app-contact-section></app-contact-section>
  </div>
  <div class="bottom-section" *ngIf="globalUtilsService.isMobile()">
    <app-bottom-section></app-bottom-section>
  </div>
</div>
